import { render, staticRenderFns } from "./item-selector.vue?vue&type=template&id=fdb360ce&scoped=true"
import script from "./item-selector.vue?vue&type=script&lang=js"
export * from "./item-selector.vue?vue&type=script&lang=js"
import style0 from "./item-selector.vue?vue&type=style&index=0&id=fdb360ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb360ce",
  null
  
)

export default component.exports